// extracted by mini-css-extract-plugin
export default {"scheduleLink":"PC_scheduleLink__95Azy","addCourse":"PC_addCourse__wuhzR"};